import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { BottomSheetContentLayout, MenuItem, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
export const GetMobileAddFilterListTID = (parentTestId)=>getTestIds(parentTestId);
export const MobileAddFilterList = (param)=>{
    let { testId, filterLabels, availableFilters, onSelect, groups } = param;
    const { MobileAddFilterListTID } = useMemo(()=>GetMobileAddFilterListTID(testId), [
        testId
    ]);
    const renderFilterItem = (filter)=>/*#__PURE__*/ _jsx(MenuItem, {
            testId: MobileAddFilterListTID.FilterOption(String(filter)),
            onClick: ()=>onSelect(filter),
            children: filterLabels[filter]
        }, String(filter));
    const renderGrouped = (filterGroups)=>filterGroups.flatMap((group)=>{
            const visibleFilters = group.filters.filter((f)=>availableFilters.includes(f));
            if (visibleFilters.length === 0) return [];
            return [
                /*#__PURE__*/ _jsx(Typography, {
                    variant: "paragraph2",
                    weight: "normal",
                    skin: "secondary",
                    children: group.label
                }, "group-".concat(group.label)),
                ...visibleFilters.map(renderFilterItem)
            ];
        });
    const renderFlat = ()=>availableFilters.map(renderFilterItem);
    return /*#__PURE__*/ _jsx(BottomSheetContentLayout, {
        header: {
            title: 'Add filter',
            paddingBottom: 8
        },
        contentGutter: "m",
        children: groups ? renderGrouped(groups) : renderFlat()
    });
};
